import { TriangleAlertIcon } from 'lucide-react'

import { Badge, TextLink } from 'slab'
import { supportLinks } from 'utils'

export const HsaBadge = ({ bordered = false, isUserQmeEligible }: { bordered?: boolean; isUserQmeEligible: boolean }) => {
  const { label, badgeType, Icon }: { label: React.ReactNode, badgeType: 'info' | 'caution', Icon?: React.ReactNode } = isUserQmeEligible
    ? {
        label: <>HSA-eligible with <TextLink href={supportLinks.hsa} target='_blank' rel='noopener noreferrer'>restrictions</TextLink></>,
        badgeType: 'caution',
        Icon: <TriangleAlertIcon aria-label='Warning icon' size={14} />
      }
    : {
        label: <>HSA-eligible</>,
        badgeType: 'info',
      }

  return (
    <Badge bordered={bordered} type={badgeType}>
      <span className='flex items-center gap-1' data-testid='hsa-eligible-badge'>
        {label}{!!Icon && Icon}
      </span>
    </Badge>
  )
}
